import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { HorizontalDivider, VerticalDivider } from '.'
import { ItemContainer } from './Items/Item'

export class Toolbar extends Component {

    static propTypes = {
        items: PropTypes.array.isRequired,
        type: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        isItemDisplayable: PropTypes.func.isRequired,
        isItemDisabled: PropTypes.func.isRequired,
    }

    divider(key) {
        if(this.props.type === 'vertical') return <HorizontalDivider key={key} />

        return <VerticalDivider key={key}/>
    }

    render() {

        const { isItemDisabled, items, isItemDisplayable, type} = this.props

        let renderedItems = []
        items.forEach(function(group, groupIndex) {
            let itemToDisplay = 0
            group.forEach(function(item, index) {
                if(! isItemDisplayable(item))
                {
                    return
                }

                renderedItems.push(<ItemContainer key={groupIndex + '-' + index} {...item} isDisabled={isItemDisabled(item)} />)
                itemToDisplay++
            })

            if(itemToDisplay > 0)
            {
                renderedItems.push(this.divider(groupIndex))
            }
        }.bind(this))

        renderedItems.pop()

        return (
            <div className={`${type}-toolbar`}>
                {renderedItems}
            </div>
        )
    }
}
